import React, { useState, useEffect } from "react";
import PieChart, {
  Series,
  Legend,
  Label,
  Connector,
  Font,
} from "devextreme-react/pie-chart";
import {
  Chart,
  Series as ChartSeries,
  CommonSeriesSettings,
  Label as ChartLabel,
  Format,
  ArgumentAxis,
  ValueAxis,
  Tick,
} from "devextreme-react/chart";
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import API from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useToast } from "../../contexts/toast";
import "./DashboardOcupation.css";

const DashboardOcupation = () => {
  const user = parsedUser();
  const toast = useToast();

  // Estados para el grid dinámico
  const [gridConfig, setGridConfig] = useState({
    rows: 'repeat(5, 1fr)',
    cols: 'repeat(5, 1fr)',
    gap: '10px',
    padding: '10px',
    height: '100vh',
    width: '100vw',
    background: '#ffffff'
  });
  const [dashboardItems, setDashboardItems] = useState([]);


  // Función para obtener datos del dashboard desde el backend
  const getDataDashboard = async () => {
    try {
      console.log("🔍 Obteniendo datos del Dashboard Disponibilidad...");

      // Enviar Token e IdUser como enteros
      const query = `Token=${user.Token}&IdUser=${user.IdUser}`;

      const response = await API.getAction(`api/OcupacionProcesos/DashboardDisponibilidad?${query}`, null);

      console.log("📊 Dashboard Response:", response.data);

      if (response.data && response.data.length > 0) {
        // Parsear el primer nivel de JSONData
        let firstLevel = JSON.parse(response.data[0].JSONData);
        console.log("📋 Primera capa Dashboard (parseada):", firstLevel);

        // Verificar errores
        if (firstLevel.Error) {
          toast({
            type: "error",
            message: firstLevel.Msg || "Error al obtener datos del Dashboard"
          });
          return;
        }

        const dashboardData = firstLevel.DashboardData;

        // 🎯 PROCESAR configuración del Grid
        if (dashboardData.Grid) {
          setGridConfig({
            rows: dashboardData.Grid.Rows || 'repeat(5, 1fr)',
            cols: dashboardData.Grid.Cols || 'repeat(5, 1fr)',
            gap: dashboardData.Grid.Gap || '10px',
            padding: dashboardData.Grid.Padding || '10px',
            height: dashboardData.Grid.height || '100vh',
            width: dashboardData.Grid.width || '100vw',
            background: dashboardData.Grid.background || '#ffffff'
          });
          console.log("✅ Configuración del Grid cargada");
        }

        // 🎯 PROCESAR Items del Dashboard
        if (dashboardData.Items && Array.isArray(dashboardData.Items)) {
          setDashboardItems(dashboardData.Items);
          console.log("✅ Items del Dashboard cargados:", dashboardData.Items.length);
        }


      } else {
        console.warn("⚠️ No se recibieron datos para el dashboard.");
        toast({
          type: "info",
          message: "No hay datos disponibles para mostrar"
        });
      }

    } catch (error) {
      console.error("❌ Error al obtener datos del Dashboard:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar los datos del dashboard"
      });
    }
  };

  // useEffect para cargar los datos al montar el componente
  useEffect(() => {
    if (user && user.Token && user.IdUser) {
      getDataDashboard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Función para renderizar Items tipo Card
  const renderCardItem = (item) => {
    // Si el item tiene GridRow con span 4 o más, son cards horizontales de estado
    const isVerticalList = item.GridRow && (item.GridRow.includes('span 4') || item.GridRow.includes('span 3'));
    
    if (isVerticalList) {
      return (
        <div className="estados-container">
          {item.ItemData.map((card, index) => (
            <div key={index} className="estado-card-container">
              <div className="estado-card" style={{ backgroundColor: card.BackColor }}>
                <div className="estado-icon" style={{ color: card.ForeColor }}>
                  <i className={card.Icon}></i>
                </div>
                <div className="estado-text" style={{ color: card.ForeColor }}>{card.Kpi}</div>
              </div>
              <div className="estado-value" style={{ backgroundColor: card.ForeColor }}>
                {card.Valor}
              </div>
            </div>
          ))}
        </div>
      );
    }

    // Cards horizontales normales (header)
    return (
      <div className="general-cards-container-wrapper">
        {item.ItemData.map((card, index) => (
          <div 
            key={index}
            className="general-card-item"
            style={{ 
              width: card.Width, 
              height: card.Height
            }}
          >
            <div
              className="general-stat-card"
              style={{ backgroundColor: card.BackColor }}
            >
              <div
                className="general-card-header"
                style={{ backgroundColor: card.ForeColor, color: card.BackColor }}
              >
                {card.Kpi}
              </div>
              <div className="general-card-body">
                <div
                  className="general-card-icon"
                  style={{ color: card.ForeColor }}
                >
                  <i className={card.Icon}></i>
                </div>
                <div
                  className="general-card-value"
                  style={{ color: card.ForeColor }}
                >
                  {card.Valor}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Función para renderizar Items tipo Pie2 (gráficos de dona)
  const renderPie2Item = (item) => {
    return (
      <div className="bg-white p-3 shadow" style={{ borderRadius: 15, height: '100%' }}>
        <h5 className="text-center mb-2 chart-title-bar">{item.ItemTitle}</h5>
        <div className="chart-donut-container">
          {item.ItemData.map((serieData, index) => (
            <div key={index} className="donut-item">
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <h6 style={{ marginBottom: '5px', fontWeight: 600, color: '#3d4d5c', fontSize: '12px', flexShrink: 0 }}>
                  {serieData.Serie}
                </h6>
                <PieChart
                  dataSource={serieData.Data.map(d => ({
                    category: d.Kpi,
                    value: d.Valor,
                    color: d.BackColor
                  }))}
                  resolveLabelOverlapping="shift"
                  innerRadius={0.7}
                  type="doughnut"
                  customizePoint={(pointInfo) => ({ color: pointInfo.data.color })}
                >
                  <Series argumentField="category" valueField="value">
                    <Label
                      visible={true}
                      format="fixedPoint"
                      customizeText={(pointInfo) => `${pointInfo.argumentText}: ${pointInfo.valueText}`}
                      position="columns"
                    >
                      <Connector visible={true} width={1}></Connector>
                      <Font size={10} weight={600} color="#FFFFFF" />
                    </Label>
                  </Series>
                  <Legend visible={false} />
                </PieChart>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Función para renderizar Items tipo StackedBar
  const renderStackedBarItem = (item) => {
    if (!item.ItemData || !item.ItemData[0]) return null;

    const chartData = item.ItemData[0];
    const series = chartData.Series;
    const data = chartData.Data.map(d => {
      const dataPoint = { name: d.Kpi };
      series.forEach(s => {
        dataPoint[s.Serie] = d[s.Serie];
      });
      return dataPoint;
    });

    return (
      <div className="bg-white p-3 shadow" style={{ borderRadius: 15, height: '100%' }}>
        <h5 className="text-center mb-2 chart-title-bar">{item.ItemTitle}</h5>
        <Chart
          dataSource={data}
          rotated={true}
          barGroupPadding={0.2}
        >
          <CommonSeriesSettings
            argumentField="name"
            type="stackedBar"
            hoverMode="allArgumentPoints"
            selectionMode="allArgumentPoints"
          >
            <ChartLabel visible={true}>
              <Format type="fixedPoint" precision={0} />
              <Font size={14} weight={600} />
            </ChartLabel>
          </CommonSeriesSettings>

          {series.map((serie, index) => (
            <ChartSeries 
              key={index}
              valueField={serie.Serie} 
              name={serie.Kpi} 
              color={serie.Color} 
              stack="total" 
            />
          ))}

          <ArgumentAxis>
            <Font size={12} />
          </ArgumentAxis>

          <ValueAxis>
            <Tick visible={true} />
          </ValueAxis>

          <Legend visible={false} />
        </Chart>
      </div>
    );
  };

  return (
    <>
      <Breadcrumbs pathTitle={"Dashboard de Ocupación"} />
      <div 
        className="dashboard-grid-container-dynamic"
        style={{
          display: 'grid',
          gridTemplateRows: gridConfig.rows,
          gridTemplateColumns: gridConfig.cols,
          gap: gridConfig.gap,
          padding: gridConfig.padding,
          height: gridConfig.height,
          width: gridConfig.width,
          backgroundColor: gridConfig.background,
          boxSizing: 'border-box',
          overflow: 'hidden'
        }}
      >
        {dashboardItems.map((item, index) => {
          let content = null;

          // Renderizar según el tipo de item
          switch (item.ItemType) {
            case 'Card':
              content = renderCardItem(item);
              break;
            case 'Pie2':
              content = renderPie2Item(item);
              break;
            case 'StackedBar':
              content = renderStackedBarItem(item);
              break;
            default:
              console.warn(`Tipo de item no soportado: ${item.ItemType}`);
              content = <div>Tipo no soportado: {item.ItemType}</div>;
          }

          return (
            <div
              key={item.ItemIndex}
              className="grid-item-dynamic"
              style={{
                gridRow: item.GridRow,
                gridColumn: item.GridCol
              }}
            >
              {content}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DashboardOcupation;
